<div *ngIf="!totalCount || totalCount <= 10">
  <canvas baseChart [chartType]="'bar'" [options]="optionsForLessThanTen" [datasets]="barData.datasets" [colors]="barColors"
    [labels]="barData.labels" [legend]="false" height="170"></canvas>
</div>
<div *ngIf="totalCount && totalCount > 10">
  <canvas baseChart [chartType]="'bar'" [options]="optionsForGreaterThanTen" [datasets]="barData.datasets" [colors]="barColors"
    [labels]="barData.labels" [legend]="false" height="170"></canvas>
</div>